function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Cloud Firestore (7- Raw Icon, Light)");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Cloud-Firestore-(7--Raw-Icon,-Light)",
  transform: "translate(-24.000000, -16.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 192 0 192 192 0 192"
}), React.createElement("path", {
  d: "M96,104 L24,136 L24,104 L96,72 L168,104 L168,132 L168,126 L168,136 L96,104 Z M96,16 L168,48 L168,80 L96,48 L24,80 L24,48 L96,16 Z M123,132 L159,148 L96,176 L96,144 L123,132 Z",
  id: "Shape",
  fill: "#FFFFFF"
})));

var SvgFirestore = function SvgFirestore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "144px",
    height: "160px",
    viewBox: "0 0 144 160",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFirestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firestore.2b890df1.svg";
export { ForwardRef as ReactComponent };